import { Suspense } from "react";

import { useIntl } from "react-intl";

import { CfLoader } from "@/shared/components/common/CfLoader/CfLoader";
import { BaseContainer } from "@/shared/containers/BaseContainer/BaseContainer";
import { usePageTitle } from "@/shared/hooks/usePageTitle";

import { Reset } from "./Reset";

const ResetWrapper = (): React.ReactElement => {
  const intl = useIntl();
  usePageTitle(intl.formatMessage({ id: "reset.header" }));

  return (
    <BaseContainer>
      <Suspense fallback={<CfLoader />}>
        <Reset />
      </Suspense>
    </BaseContainer>
  );
};

export { ResetWrapper };
